module.exports = __webpack_public_path__ + "img/6.9ef7d835.png";